export function getChatDraftKey(
  workspaceId: string | null | undefined,
  threadId: string | null | undefined
): string {
  return `chat_draft:${workspaceId ?? "personal"}:${threadId ?? "new"}`;
}

export function readChatDraft(key: string): string {
  if (typeof window === "undefined") return "";
  try {
    return sessionStorage.getItem(key) ?? "";
  } catch {
    return "";
  }
}

export function writeChatDraft(key: string, value: string): void {
  if (typeof window === "undefined") return;
  try {
    if (value.trim()) {
      sessionStorage.setItem(key, value);
    } else {
      sessionStorage.removeItem(key);
    }
  } catch {
    // ignore quota / private mode
  }
}

export function clearChatDraft(key: string): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(key);
  } catch {
    // ignore
  }
}
